import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistReducer, persistStore } from 'redux-persist';
import localStorage from 'redux-persist/lib/storage';

import authReducer from 'store/reducers/auth';
import cartReducer from 'store/reducers/cart';
import commonReducer from 'store/reducers/common';
import leisurePurchaseReducer from 'store/reducers/leisurePurchaseReducer';
import persistedCart from 'store/reducers/persistedCart';
import travelPurchaseReducer from 'store/reducers/travelPurchaseReducer';

const authPersistConfig = { key: 'auth', storage: localStorage, whitelist: ['autolog'] };
const travelPurchasePersistConfig = { key: 'travelPurchase', storage: localStorage };
const leisurePurchasePersistConfig = { key: 'leisurePurchase', storage: localStorage };
const cartTimerPersistConfig = { key: 'persistedCart', storage: localStorage };

const rootReducer = combineReducers({
  common: commonReducer,
  auth: persistReducer(authPersistConfig, authReducer),
  cart: cartReducer,
  persistedCart: persistReducer(cartTimerPersistConfig, persistedCart),
  travelPurchase: persistReducer(travelPurchasePersistConfig, travelPurchaseReducer),
  leisurePurchase: persistReducer(leisurePurchasePersistConfig, leisurePurchaseReducer)
});

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  /* Necessary to ignore serialization verifications when using Redux persist */
  /* https://redux-toolkit.js.org/usage/usage-guide#use-with-redux-persist) */
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
});

export const persistor = persistStore(store);
